import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import NumericBox from '../../components/NumericBox.js';
import { getWords } from '../../utils/get-words.js';

const BudgetOperationTopPart3Part1 = ReactRouterDOM.withRouter(function ({ budgetOperation, body, updateBody, validated }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);

  return (
    <div>
      <div>
        <div className="d-flex justify-content-between">
          <div className="pt-2">
            <NumericBox
              label={words.jan}
              value={body.janCount}
              onChange={(value) => updateBody('janCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.feb}
              value={body.febCount}
              onChange={(value) => updateBody('febCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.mar}
              value={body.marCount}
              onChange={(value) => updateBody('marCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.apr}
              value={body.aprCount}
              onChange={(value) => updateBody('aprCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.may}
              value={body.mayCount}
              onChange={(value) => updateBody('mayCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.jun}
              value={body.junCount}
              onChange={(value) => updateBody('junCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.jul}
              value={body.julCount}
              onChange={(value) => updateBody('julCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.aug}
              value={body.augCount}
              onChange={(value) => updateBody('augCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.sep}
              value={body.sepCount}
              onChange={(value) => updateBody('sepCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.oct}
              value={body.octCount}
              onChange={(value) => updateBody('octCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.nov}
              value={body.novCount}
              onChange={(value) => updateBody('novCount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.dec}
              value={body.decCount}
              onChange={(value) => updateBody('decCount', value)}
              validated={validated}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
})

export default BudgetOperationTopPart3Part1;
